{
	"four-simple-steps": "Four simple steps when using a post box",
	"get-the-app": "Get the app",
	"login": "Login",
	"pickup": "Pickup all over the country",
	"ship-products": "Ship your products to the parcel locker",
	"simple-login": "Simple login"
}
